module.exports = "<div class=row> <div class=col-xs-12> <div class=form-group> <app-widgets-label i18n-label=\"Climbing Route Teaser\"></app-widgets-label> <app-i18n-p text=route.teaser main-lang=route.main_lang multiline=true></app-i18n-p> </div> </div> </div> <div class=row> <div class=col-xs-12> <div class=form-group> <app-widgets-label label=$ctrl.historyLabel></app-widgets-label> <app-i18n-p text=route.history main-lang=route.main_lang multiline=true></app-i18n-p> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/view/general/partial_alpine_climbing.html
// module id = 500
// module chunks = 0